// 阿里云函数 API 地址
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://sunray-t-system-kweoytfwwx.cn-chengdu.fcapp.run';

// 本地存储 key
const AUTH_TOKEN_KEY = 'admin_auth_token';
const AUTH_USER_KEY = 'admin_auth_user';

/**
 * Admin login with Aliyun FC
 *
 * @param username - Admin username
 * @param password - Admin password
 * @returns Success status and user data or error message
 */
export const loginAdmin = async (username: string, password: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      return {
        success: false,
        error: result.error || '登录失败，请检查用户名和密码'
      };
    }

    // 存储 token 和用户信息
    localStorage.setItem(AUTH_TOKEN_KEY, result.token);
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(result.user));

    return {
      success: true,
      user: {
        uid: result.token,
        email: result.user.username,
        username: result.user.username,
        sessionToken: result.token
      }
    };
  } catch (error: any) {
    console.error('Login error:', error);
    return {
      success: false,
      error: error.message || '登录失败，网络错误'
    };
  }
};

/**
 * Admin logout
 */
export const logoutAdmin = async () => {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
    return { success: true };
  } catch (error: any) {
    console.error('Logout error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get current authenticated user
 */
export const getCurrentUser = async () => {
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const userStr = localStorage.getItem(AUTH_USER_KEY);

    if (!token || !userStr) return null;

    const user = JSON.parse(userStr);
    return {
      uid: token,
      email: user.username,
      username: user.username,
      sessionToken: token
    };
  } catch (error) {
    console.error('Get current user error:', error);
    return null;
  }
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = async (): Promise<boolean> => {
  const user = await getCurrentUser();
  return user !== null;
};
